var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React from 'react';
import Session from 'containers/Session';
import Page from 'pages/Support';
var Support = function () {
    return (_jsx(Session, { children: function (sessionProps) { return _jsx(Page, __assign({}, sessionProps), void 0); } }, void 0));
};
export default Support;
